export const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]

export const dayHeaders = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']

export const monthNamesUppercase = {
  ENERO: 1,
  FEBRERO: 2,
  MARZO: 3,
  ABRIL: 4,
  MAYO: 5,
  JUNIO: 6,
  JULIO: 7,
  AGOSTO: 8,
  SEPTIEMBRE: 9,
  OCTUBRE: 10,
  NOVIEMBRE: 11,
  DICIEMBRE: 12,
} as const

export const parseBillingMonth = (billingMonth: string): { month: number; year: string } => {
  let month: number = 1
  let year = ''

  if (billingMonth.includes(' de ')) {
    const parts = billingMonth.split(' de ')
    const monthName = parts[0].toUpperCase()
    month = monthNamesUppercase[monthName as keyof typeof monthNamesUppercase] || 1
    year = parts[1]
  } else if (billingMonth.includes('/')) {
    const dateParts = billingMonth.split('/')
    month = parseInt(dateParts[0], 10)
    year = dateParts[1]
  } else {
    const billingMonthParts = billingMonth.split(' ')
    if (billingMonthParts.length === 2) {
      const monthName = billingMonthParts[0].toUpperCase()
      month = monthNamesUppercase[monthName as keyof typeof monthNamesUppercase] || 1
      year = billingMonthParts[1]
    }
  }

  return { month, year }
}

export const formatMonthYear = (month: number, year: string): string => {
  const monthName = months[month - 1]
  return `${monthName} ${year}`
}
